import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';

import {YukitModule} from 'yukit';
import {ScrollingModule} from '@angular/cdk/scrolling';
import {PipesModule} from '../Pipes/pipes.module';
import {NgApexchartsModule} from 'ng-apexcharts';
import {MarkdownModule} from 'ngx-markdown';
import {TranslateModule} from '@ngx-translate/core';

import {EmptyItemComponent} from './Empty-states/empty-item/empty-item.component';
import {EmptyWidgetComponent} from './Empty-states/empty-widget/empty-widget.component';
import {EmptyButtonComponent} from './Empty-states/empty-button/empty-button.component';
import {YuDatetimeComponent, YuDatetimeModal} from './Controls/yu-datetime/yu-datetime.component';
import {FilterSwiperComponent} from './Controls/yu-filter/filter-swiper/filter-swiper.component';
import {FilterWrapperComponent} from './Controls/yu-filter/filter-wrapper/filter-wrapper.component';
import {FilterButtonComponent} from './Controls/yu-filter/filter-button/filter-button.component';
import {ModalSelectorComponent} from './Controls/yu-selector/modal-selector/modal-selector.component';
import {SearchSelectorComponent} from './Controls/yu-selector/search-selector/search-selector.component';
import {YuCustomItemComponent} from './Items/List/yu-custom-item/yu-custom-item.component';
import {NotificationItemComponent} from './Items/Notifications/notification-item/notification-item.component';
import {ModuleButtonComponent} from './Items/Modules/module-button/module-button.component';
import {FavoritesModulesSwiperComponent} from './Items/Modules/favorites-modules-swiper/favorites-modules-swiper.component';
import {FileInfoItemComponent} from './Items/Rrhh/Folders/file-info-item/file-info-item.component';
import {KeyboardComponent} from './Controls/keyboard/keyboard.component';
import {WeekSliderComponent} from './Controls/yu-date-slider/week-slider/week-slider.component';
import {MonthSliderComponent} from './Controls/yu-date-slider/month-slider/month-slider.component';
import {YearSliderComponent} from './Controls/yu-date-slider/year-slider/year-slider.component';
import {ClockInItemComponent} from './Items/Rrhh/Clock-in/clock-in-item/clock-in-item.component';
import {UserClockInItemComponent} from './Items/Rrhh/Clock-in/user-clock-in-item/user-clock-in-item.component';
import {ScheduleItemComponent} from './Items/Rrhh/Schedules/schedule-item/schedule-item.component';
import {ProviderProductItemComponent} from './Items/Purchases/Providers/provider-product-item/provider-product-item.component';
import {DataBlockComponent} from './Items/Purchases/Shared/data-block/data-block.component';
import {FooterTotalsBlockComponent} from './Items/Purchases/Shared/footer-totals-block/footer-totals-block.component';
import {AmountBlockComponent} from './Items/Purchases/Shared/amount-block/amount-block.component';
import {OrderWeightBlockComponent} from './Items/Purchases/Orders/order-weight-block/order-weight-block.component';
import {LinesItemComponent} from './Items/Purchases/Shared/lines-item/lines-item.component';
import {PendentLinesItemComponent} from './Items/Purchases/Shared/pendent-lines-item/pendent-lines-item.component';
import {AddProductItemComponent} from './Items/Purchases/Shared/add-product-item/add-product-item.component';
import {CashClosingDataComponent} from './Items/Finances/Cash-closing/cash-closing-data/cash-closing-data.component';
import {CashClosingItemComponent} from './Items/Finances/Cash-closing/cash-closing-item/cash-closing-item.component';
import {WidgetDataComponent} from './Widgets/Reports/widget-data/widget-data.component';
import {WidgetCoreComponent} from './Widgets/Reports/widget-core/widget-core.component';
import {WidgetGaugeChartComponent} from './Widgets/Reports/widget-gauge-chart/widget-gauge-chart.component';
import {WidgetLineChartComponent} from './Widgets/Reports/widget-line-chart/widget-line-chart.component';
import {WidgetBarChartComponent} from './Widgets/Reports/widget-bar-chart/widget-bar-chart.component';
import {WidgetPieChartComponent} from './Widgets/Reports/widget-pie-chart/widget-pie-chart.component';
import {ExpenseAmountBlockComponent} from './Items/Finances/Expenses/expense-amount-block/expense-amount-block.component';
import {ListHeaderExpenseComponent} from './Items/Finances/Expenses/list-header-expense/list-header-expense.component';
import {ExpensePaidStatusComponent} from './Items/Finances/Expenses/expense-paid-status/expense-paid-status.component';
import {ImageBannerSwiperComponent} from './Controls/image-banner-swiper/image-banner-swiper.component';
import {ProductionButtonComponent} from './Items/YuChef/Productions/production-button/production-button.component';
import {LabeledButtonComponent} from './Items/YuChef/Labeled/labeled-button/labeled-button.component';
import {YuRatingComponent} from './Controls/yu-rating/yu-rating.component';
import {TaskItemComponent} from './Items/Tasks/Items/task-item/task-item.component';
import {TaskDataBlockComponent} from './Items/Tasks/Items/task-data-block/task-data-block.component';
import {YuFileComponent} from './Controls/yu-file-input/yu-file/yu-file.component';
import {YuFileItemComponent} from './Controls/yu-file-input/yu-file-item/yu-file-item.component';
import {SendMessageItemComponent} from './Items/Chats/send-message-item/send-message-item.component';
import {MessageItemComponent} from './Items/Chats/message-item/message-item.component';
import {PlatformItemComponent} from './Items/Tasks/Platforms/platform-item/platform-item.component';
import {CoreFieldComponent} from './Items/Tasks/Fields/core-field/core-field.component';
import {FieldItemComponent} from './Items/Tasks/Fields/field-item/field-item.component';
import {TitleFieldComponent} from './Items/Tasks/Fields/title-field/title-field.component';
import {TaskActionComponent} from './Items/Tasks/Items/task-action/task-action.component';
import {CounterInputComponent} from './Controls/counter-input/counter-input.component';
import {TransferDataComponent} from './Items/Warehouse/Transfers/transfer-data/transfer-data.component';
import {TransferAmountComponent} from './Items/Warehouse/Transfers/transfer-amount/transfer-amount.component';
import {SignaturePadComponent} from './Controls/signature-pad/signature-pad.component';
import {MultisessionUserComponent} from './Items/Multisession/multisession-user/multisession-user.component';
import {WidgetSwitchComponent} from './Widgets/Home/Core/widget-switch/widget-switch.component';
import {WidgetsGridComponent} from './Widgets/Home/Core/widgets-grid/widgets-grid.component';
import {WidgetsEmptyComponent} from './Widgets/Home/Core/widgets-empty/widgets-empty.component';
import {WidgetHomeCoreComponent} from './Widgets/Home/Shared/widget-home-core/widget-home-core.component';
import {WidgetPrincipalDataComponent} from './Widgets/Home/Shared/widget-principal-data/widget-principal-data.component';
import {CompletedChecklistsWidgetComponent} from './Widgets/Home/Tasks/completed-checklists-widget/completed-checklists-widget.component';
import {CompletedAuditWidgetComponent} from './Widgets/Home/Tasks/completed-audit-widget/completed-audit-widget.component';
import {CompletedAppccWidgetComponent} from './Widgets/Home/Tasks/completed-appcc-widget/completed-appcc-widget.component';
import {AuditValuationWidgetComponent} from './Widgets/Home/Tasks/audit-valuation-widget/audit-valuation-widget.component';
import {PendentsTransfersWidgetComponent} from './Widgets/Home/Warehouse/pendents-transfers-widget/pendents-transfers-widget.component';
import {LastOrdersWidgetComponent} from './Widgets/Home/Purchases/last-orders-widget/last-orders-widget.component';
import {CommunicationItemComponent} from './Items/Communication/communication-item/communication-item.component';
import {CommunicationDataBlockComponent} from './Items/Communication/communication-data-block/communication-data-block.component';
import {PurchasesScheduledPendentsWidgetComponent} from './Widgets/Home/Purchases/purchases-scheduled-pendents-widget/purchases-scheduled-pendents-widget.component';
import {InventoryScheduledPendentsWidgetComponent} from './Widgets/Home/Warehouse/inventory-scheduled-pendents-widget/inventory-scheduled-pendents-widget.component';
import {EbitdaWidgetComponent} from './Widgets/Home/Finances/ebitda-widget/ebitda-widget.component';
import {EbitdaPurchasesWidgetComponent} from './Widgets/Home/Finances/ebitda-purchases-widget/ebitda-purchases-widget.component';
import {EbitdaPersonalWidgetComponent} from './Widgets/Home/Finances/ebitda-personal-widget/ebitda-personal-widget.component';
import {EbitdaGeneralWidgetComponent} from './Widgets/Home/Finances/ebitda-general-widget/ebitda-general-widget.component';
import {EbitdaIncomeWidgetComponent} from './Widgets/Home/Finances/ebitda-income-widget/ebitda-income-widget.component';
import {PendentsBreakdownsWidgetComponent} from './Widgets/Home/Communication/pendents-breakdowns-widget/pendents-breakdowns-widget.component';
import {UnreadCommunicationsWidgetComponent} from './Widgets/Home/Communication/unread-communications-widget/unread-communications-widget.component';
import {NotReceivedOrdersWidgetComponent} from './Widgets/Home/Purchases/not-received-orders-widget/not-received-orders-widget.component';
import {NotSentOrdersWidgetComponent} from './Widgets/Home/Purchases/not-sent-orders-widget/not-sent-orders-widget.component';
import {LastClockInWidgetComponent} from './Widgets/Home/Rrhh/last-clock-in-widget/last-clock-in-widget.component';
import {AssistantRingComponent} from './Assistant/assistant-ring/assistant-ring.component';
import {AssistantInputComponent} from './Assistant/assistant-input/assistant-input.component';
import {AssistantMessageComponent} from './Assistant/assistant-message/assistant-message.component';
import {AssistantSuggestionComponent} from './Assistant/assistant-suggestion/assistant-suggestion.component';
import {AssistantLoaderComponent} from './Assistant/assistant-loader/assistant-loader.component';
import {AssistantMenuComponent} from './Assistant/assistant-menu/assistant-menu.component';
import {AssistantPurchaseOrderComponent} from './Assistant/assistant-purchase-order/assistant-purchase-order.component';
import {OrderStatusTrackComponent} from './Items/Purchases/Orders/order-status-track/order-status-track.component';
import {EventDataBlockComponent} from './Items/Events/event-data-block/event-data-block.component';
import {ClockInReportItemComponent} from './Items/Reports/Rrhh/clock-in-report-item/clock-in-report-item.component';
import {ClockInDetailReportItemComponent} from './Items/Reports/Rrhh/clock-in-detail-report-item/clock-in-detail-report-item.component';
import {DocumentsReviewWidgetComponent} from './Widgets/Home/Documents-review/documents-review-widget/documents-review-widget.component';
import {PayrollsReviewWidgetComponent} from './Widgets/Home/Documents-review/payrolls-review-widget/payrolls-review-widget.component';
import {ExpensesReviewWidgetComponent} from './Widgets/Home/Documents-review/expenses-review-widget/expenses-review-widget.component';
import {DeliveryNotesReviewWidgetComponent} from './Widgets/Home/Documents-review/delivery-notes-review-widget/delivery-notes-review-widget.component';
import {UnclassifiedReviewWidgetComponent} from './Widgets/Home/Documents-review/unclassified-review-widget/unclassified-review-widget.component';
import {YuTimePickerComponent, YuTimePickerModal} from './Controls/yu-time-picker/yu-time-picker.component';

const declarationsExports: any[] =
  [
    EmptyItemComponent,
    EmptyWidgetComponent,
    EmptyButtonComponent,
    YuDatetimeComponent,
    YuDatetimeModal,
    FilterWrapperComponent,
    FilterButtonComponent,
    FilterSwiperComponent,
    ModalSelectorComponent,
    SearchSelectorComponent,
    KeyboardComponent,
    WeekSliderComponent,
    MonthSliderComponent,
    YearSliderComponent,
    YuCustomItemComponent,
    ModuleButtonComponent,
    FavoritesModulesSwiperComponent,
    NotificationItemComponent,
    FileInfoItemComponent,
    ClockInItemComponent,
    UserClockInItemComponent,
    ScheduleItemComponent,
    ProviderProductItemComponent,
    OrderWeightBlockComponent,
    DataBlockComponent,
    FooterTotalsBlockComponent,
    AmountBlockComponent,
    LinesItemComponent,
    PendentLinesItemComponent,
    AddProductItemComponent,
    CashClosingDataComponent,
    CashClosingItemComponent,
    WidgetCoreComponent,
    WidgetDataComponent,
    WidgetGaugeChartComponent,
    WidgetLineChartComponent,
    WidgetBarChartComponent,
    WidgetPieChartComponent,
    ExpenseAmountBlockComponent,
    ListHeaderExpenseComponent,
    ExpensePaidStatusComponent,
    ImageBannerSwiperComponent,
    ProductionButtonComponent,
    LabeledButtonComponent,
    YuRatingComponent,
    TaskItemComponent,
    TaskDataBlockComponent,
    YuFileComponent,
    YuFileItemComponent,
    SendMessageItemComponent,
    MessageItemComponent,
    PlatformItemComponent,
    CoreFieldComponent,
    FieldItemComponent,
    TitleFieldComponent,
    TaskActionComponent,
    CounterInputComponent,
    TransferDataComponent,
    TransferAmountComponent,
    SignaturePadComponent,
    MultisessionUserComponent,
    WidgetSwitchComponent,
    WidgetsGridComponent,
    WidgetsEmptyComponent,
    WidgetHomeCoreComponent,
    WidgetPrincipalDataComponent,
    CompletedChecklistsWidgetComponent,
    CompletedAuditWidgetComponent,
    CompletedAppccWidgetComponent,
    AuditValuationWidgetComponent,
    PendentsTransfersWidgetComponent,
    LastOrdersWidgetComponent,
    PurchasesScheduledPendentsWidgetComponent,
    InventoryScheduledPendentsWidgetComponent,
    CommunicationItemComponent,
    CommunicationDataBlockComponent,
    EbitdaWidgetComponent,
    EbitdaPurchasesWidgetComponent,
    EbitdaPersonalWidgetComponent,
    EbitdaGeneralWidgetComponent,
    EbitdaIncomeWidgetComponent,
    PendentsBreakdownsWidgetComponent,
    UnreadCommunicationsWidgetComponent,
    NotReceivedOrdersWidgetComponent,
    NotSentOrdersWidgetComponent,
    DeliveryNotesReviewWidgetComponent,
    ExpensesReviewWidgetComponent,
    PayrollsReviewWidgetComponent,
    DocumentsReviewWidgetComponent,
    UnclassifiedReviewWidgetComponent,
    LastClockInWidgetComponent,
    AssistantRingComponent,
    AssistantInputComponent,
    AssistantMessageComponent,
    AssistantSuggestionComponent,
    AssistantLoaderComponent,
    AssistantMenuComponent,
    AssistantPurchaseOrderComponent,
    OrderStatusTrackComponent,
    EventDataBlockComponent,
    ClockInReportItemComponent,
    ClockInDetailReportItemComponent,
    YuTimePickerComponent,
    YuTimePickerModal,
  ];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    PipesModule,
    ScrollingModule,
    YukitModule,
    NgApexchartsModule,
    MarkdownModule,
    TranslateModule,
  ],
  declarations: [...declarationsExports],
  exports: [...declarationsExports],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ComponentsModule {
}
